import type React from "react";

interface ColourShiftToolProps {
	hue: number;
	saturation: number;
	preset?: "Cyanopsia" | "Xanthopsia";
	onChange: (params: {
		hue: number;
		saturation: number;
		preset?: "Cyanopsia" | "Xanthopsia";
	}) => void;
}

export const ColourShiftTool: React.FC<ColourShiftToolProps> = ({
	hue,
	saturation,
	preset,
	onChange,
}) => {
	const handlePreset = (preset: "Cyanopsia" | "Xanthopsia") => {
		if (preset === "Cyanopsia") {
			onChange({ hue: 180, saturation: 1.5 });
		} else if (preset === "Xanthopsia") {
			onChange({ hue: -60, saturation: 1.5 });
		}
	};
	return (
		<div className="p-4">
			<div className="mb-2 font-semibold">Colour Shift</div>
			<div className="flex gap-2 mb-2">
				{["Cyanopsia", "Xanthopsia"].map((p) => (
					<button
						key={p}
						className={"px-2 py-1 rounded bg-gray-200"}
						onClick={() => handlePreset(p as any)}
					>
						{p}
					</button>
				))}
			</div>
			<label className="block text-xs mb-1">Hue: {hue}</label>
			<input
				type="range"
				min={-180}
				max={180}
				value={hue}
				onChange={(e) => onChange({ hue: Number(e.target.value), saturation })}
			/>
			<label className="block text-xs mb-1 mt-2">
				Saturation: {saturation}
			</label>
			<input
				type="range"
				min={0}
				max={2}
				step={0.01}
				value={saturation}
				onChange={(e) => onChange({ hue, saturation: Number(e.target.value) })}
			/>
		</div>
	);
};
